<template>
  <OmtStickedModal
    v-if="isOpen"
    data-cy="refund-list-filter-modal"
    :headerBind="{
      padding: ['16px', '82px 42px 0px 42px']
    }"
    :bodyBind="{
      padding: ['16px 16px 24px 16px', '68px 42px 24px 42px']
    }"
    @close="close"
  >
    <template #header>
      <OmtButton
        :display="['block', 'none']"
        class="clear"
        variant="ghost"
        height="18px"
        p="0"
        @click="clear"
      >
        <OmtTypography
          as="p1"
          h="18px"
          w="46px"
          position="relative"
        >
          Limpar
        </OmtTypography>
      </OmtButton>
    </template>

    <CBox :minHeight="['initial', 'calc(100vh - 400px)']">
      <CFlex
        justifyContent="space-between"
        :mb="['24px', '36px']"
      >
        <OmtTypography as="h1-bold"> Filtros </OmtTypography>
        <OmtButton
          class="clear"
          variant="ghost"
          height="18px"
          p="0"
          :display="['none', 'block']"
          @click="clear"
        >
          <OmtTypography
            as="p1"
            h="18px"
            w="46px"
            position="relative"
          >
            Limpar
          </OmtTypography>
        </OmtButton>
      </CFlex>
      <CFlex
        v-for="(filter, index) in modalFilters"
        :key="index"
        justify="space-between"
        cursor="pointer"
        mb="24px"
        data-cy="refund-option"
        @click="filter.isActive = !filter.isActive"
      >
        <OmtTypography as="p1"> {{ filter.label }} </OmtTypography>
        <OmtCheckbox
          :is-checked="filter.isActive"
          @change="filter.isActive = !filter.isActive"
        />
      </CFlex>

      <CBox mb="32px">
        <OmtTypography
          as="h2-bold"
          mb="22px"
        >
          Por período</OmtTypography
        >
        <OmtSelect
          variant="outline"
          placeholder="Selecione um período"
          mb="24px"
          :initialValue="selectedPeriod != null ? String(selectedPeriod) : '0'"
          @change="e => changePeriod(e)"
        >
          <option
            v-for="(filter, index) in periodos"
            :key="index"
            :value="String(index)"
          >
            {{ filter }}
          </option>
        </OmtSelect>
      </CBox>
    </CBox>

    <template #footer>
      <OmtButton
        w="100%"
        @click="save"
      >
        Aplicar
      </OmtButton>
    </template>
  </OmtStickedModal>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";

/**
 * @prop {Boolean} isOpen
 * @type {{ label: string, isActive: boolean }} filterType
 * @prop {filterType} filters
 * @Event {(Array<filterType>) => void} save
 */
export default {
  props: {
    isOpen: {
      Type: Boolean
    },
    filtersHasChanges: {
      type: Boolean
    },
    filters: {
      type: Array
    }
  },
  computed: {
    ...mapState("refund", ["selectedPeriod"])
  },
  data() {
    return {
      modalFilters: [],
      periodos: ["15 dias", "30 dias", "60 dias", "2 anos"]
    };
  },
  methods: {
    ...mapMutations("refund", ["SET_PERIOD_SELECTED"]),
    ...mapActions("refund", ["fetchProtocols"]),
    close() {
      this.$emit("update:isOpen", false);
    },
    changePeriod(selectedPeriod) {
      const period = Number(selectedPeriod);
      this.SET_PERIOD_SELECTED(period);
    },
    clear() {
      this.modalFilters.forEach(f => (f.isActive = false));
      this.changePeriod(0);
    },
    async save() {
      if (Number(this.initialSelectedPeriod) !== Number(this.selectedPeriod)) {
        try {
          this.$root.$emit("show-loading");
          await this.fetchProtocols();
        } catch (error) {
          console.error(error);
        } finally {
          this.$root.$emit("hide-loading");
        }
      }
      this.$emit("save", this.modalFilters);
      this.close();
    }
  },
  watch: {
    isOpen: {
      handler() {
        this.modalFilters = structuredClone(this.filters);
        this.initialSelectedPeriod =
          this.selectedPeriod !== null && this.selectedPeriod !== undefined ? String(this.selectedPeriod) : "2";

        if (this.selectedPeriod === null || this.selectedPeriod === undefined) {
          this.SET_PERIOD_SELECTED(2);
        }
      },
      immediate: true
    },
    modalFilters: {
      handler(filters) {
        const hasChanges = filters.filter(filter => !!filter.isActive);
        this.$emit("update:filtersHasChanges", !!hasChanges.length);
      },
      deep: true
    },
    filters: {
      handler(filters) {
        const hasChanges = filters.filter(filter => !!filter.isActive);
        this.$emit("update:filtersHasChanges", !!hasChanges.length);
      },
      deep: true
    }
  }
};
</script>
